<template>
    <label
        class="relative ml-4 inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
        :class="{
            'bg-orange': props.value && !props.disabled,
            'bg-gray-200': !props.value || props.disabled,
            'cursor-pointer': !props.disabled,
            'cursor-not-allowed opacity-60': props.disabled
        }"
        role="switch"
    >
        <span class="sr-only">{{ label }}</span>
        <input
            type="checkbox"
            class="sr-only"
            @change="handleInput"
            :value="props.value"
            :checked="isChecked"
            :disabled="props.disabled"
        />
        <span
            aria-hidden="true"
            class="inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
            :class="{
                'translate-x-5': props.value,
                'translate-x-0': !props.value,
            }"
        ></span>
        <i
            class="fa-solid fa-check fa-xs absolute top-2.5 right-1 transition"
            :class="{
                'opacity-100 delay-300': props.value,
                'opacity-0': !props.value,
                'text-orange': !props.disabled,
                'text-gray-400': props.disabled
            }"
        ></i>
    </label>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    value: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['input']);
const isChecked = computed(() => props.value);

const handleInput = (value) => {
    if (props.disabled) return;
    emit('input', value.target.checked);
};
</script>
